import { withViewModel } from '../../../infrastructure/components/with-view-model';
import { AIAgentAccessFormPresentation } from './ai-agent-access-form.presentation';
import { AIAgentAccessFormVM } from './ai-agent-access-form.viewmodel';

interface IProps {
    vm: AIAgentAccessFormVM;
}

const AIAgentAccessFormContainer = withViewModel(
    AIAgentAccessFormPresentation,
    (props: IProps) => {
        return props.vm;
    }
);

export { AIAgentAccessFormContainer as AIAgentAccessForm };
